import RemoteCall from "../../../util/RemoteCall";

const remoteCall = new RemoteCall("/api/noAuth/nursecare/sms");

const sendAsync = (params) => {
    return remoteCall.invoke("send", params);
};

export default {
    sendAsync,
};
